import moment from "moment-timezone";
import { serverTimesampToNormalDate } from "utils/AppUtils";

function ExpirationColumn({ timestamp }) {
  if (!timestamp) return "-";

  const expiresAt = moment.utc(timestamp);
  const now = moment.utc();
  let className = "text-success";
  if (expiresAt.isBefore(now.clone())) className = "text-danger";
  else if (expiresAt.isBefore(now.clone().add(1, "months"))) className = "text-warning";

  return <span className={`bold ${className}`}>{serverTimesampToNormalDate(timestamp)}</span>;
}

export default ExpirationColumn;
